import React from 'react';
import Pro01 from "../../images/services/dm/technical-development.webp"
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Superiority">
                            <h2>Our Work In Numbers</h2>
                        </div>
                        <p>Think TekRevol when you think of technical development. From simple ecommerce websites to
                            large-scale B2B digital marketplaces, TekRevol has empowered global organizations with
                            digital products that boost business performance and bring high ROIs. Our global footprint
                            is stretched from established business ecosystems to emerging markets in North and South
                            America, the MENA region, Ukraine and Europe.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className=" agile_title my-auto offset-xl-1">
                        <div className=" content_pointer">
                            <div className=" pointers_item">
                                <div className=" title_count">55+<span>Applications Delivered</span></div>
                            </div>
                            <div className=" pointers_item">
                                <div className=" title_count">34+<span>Businesses Transformed</span></div>
                            </div>
                            <div className=" pointers_item">
                                <div className=" title_count">11+<span>Industries Served</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect=" blur" alt=" Image" className=" img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;